<template>
    <!-- Login Section-->
    <section class="row">
        <div class="col">
            <div class="card m-5 shadow-lg" style="width: 28rem;">
                <div class="card-body">
                <h5 class="card-title text-center"><strong><b-icon-person-circle/> Register New Customer</strong></h5>
                <hr>
                <form class="card p-3 text-left" @submit.prevent="register">
                    <div class="form-group">
                        <label for="emaillogin">Email address</label>
                        <input v-model="email" type="email" class="form-control">
                    </div>
                    <div class="form-group">
                        <label for="passwordlogin">Password</label>
                        <input v-model="password" type="password" class="form-control" id="passwordlogin">
                    </div>
                    <p id="error-msg-login" class="badge-danger text-center"></p>
                    <button type="submit" class="btn btn-primary">Register</button>
                </form>
                <div class="mt-2">
                  <p>Already have an account? <span class="btn text-primary" @click="toLogin">Login Now</span></p>
                </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    register () {
      this.$store.dispatch('register', {
        email: this.email,
        password: this.password
      })
    },
    toLogin () {
      this.$router.push({ name: 'Login' })
    }
  }
}
</script>

<style>

</style>
